'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fieldValidationService = require('./fieldValidationService');

var _fieldValidationService2 = _interopRequireDefault(_fieldValidationService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Uses the registered validators to determine whether the specified field value is valid given its field config.
 *
 * @param fieldValues {Object} An object with properties of field names and values of field values.
 * @param fieldValidationConfigs {Object} An object that specifies the validation config for each of the fields to
 *          validate.
 * @returns {Object} An object with properties for each of the fields, the value of each property is an error object
 *          for that field, or null if the field is valid.
 */
exports.default = function (fieldValues, fieldValidationConfigs) {
    var errors = {};
    var isValid = true;

    // Loop over each field config and validate based on it
    for (var fieldConfigPropName in fieldValidationConfigs) {
        if (!fieldValidationConfigs.hasOwnProperty(fieldConfigPropName)) continue;

        var fieldConfig = fieldValidationConfigs[fieldConfigPropName];
        var fieldName = fieldConfig.name;
        var fieldValue = fieldValues[fieldName];

        // Perform the validation using the 'validator service'
        errors[fieldName] = (0, _fieldValidationService2.default)(fieldValue, fieldConfig);
        isValid = isValid && !errors[fieldName];
    }

    return {
        isValid: isValid,
        errors: errors
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/validation/validationService.js
// module id = 2298
// module chunks = 0